import { createAction, handleActions } from 'redux-actions';
import http from '../../utility/http';
import {
  API_RBAC_PERMISSIONS_GROUPED,
  API_RBAC_PERMISSIONS_GROUPS_BY_ROLE,
} from '../../constants/apiRoutes';

// ------------------------------------
// Constants
// ------------------------------------

const SET_PERMISSIONS = 'SET_PERMISSIONS';
const SET_PERMISSIONS_BY_ROLE = 'SET_PERMISSIONS_BY_ROLE';
const SET_ALL_PERMISSIONS = 'SET_ALL_PERMISSIONS';

const initialState = {
  permissionsGroups: [],
  permissionsByRole: {},
};

// ------------------------------------
// Actions
// ------------------------------------

const setPermissions = createAction(SET_PERMISSIONS);
const setPermissionsByRole = createAction(SET_PERMISSIONS_BY_ROLE);
const setAllPermissions = createAction(SET_ALL_PERMISSIONS);

// ------------------------------------
// Reducers
// ------------------------------------

const reducers = {
  [SET_PERMISSIONS]: (state, { payload }) => {
    return { ...state, permissionsGroups: payload };
  },
  [SET_PERMISSIONS_BY_ROLE]: (state, { payload }) => {
    return { ...state, permissionsByRole: payload };
  },
  [SET_ALL_PERMISSIONS]: (state, { payload }) => {
    return payload;
  },
};

export const getPermissions = dispatch =>
  http
    .get(API_RBAC_PERMISSIONS_GROUPED)
    .then(({ data }) => dispatch(setPermissions(data)));

export const getPermissionsByRole = dispatch =>
  http
    .get(API_RBAC_PERMISSIONS_GROUPS_BY_ROLE)
    .then(({ data }) => dispatch(setPermissionsByRole(data)));

export default handleActions(reducers, initialState);

// ------------------------------------
// "plain" action functions
// ------------------------------------

export const clearPermissions = () => setAllPermissions(initialState);
